<div class="dialog-backdrop" role="dialog" aria-labelledby="dialog-title" aria-describedby="dialog-desc">
  <div class="dialog-content">
    <h2 id="dialog-title">{{ title }}</h2>
    <p id="dialog-desc">{{ message }}</p>
    <div class="dialog-actions">
      <button class="nhsuk-button" data-module="nhsuk-button" type="button" (click)="onConfirm()" aria-label="Confirm">
        Confirm
      </button>
      <button
        class="nhsuk-button nhsuk-button--secondary"
        data-module="nhsuk-button"
        type="button"
        (click)="onCancel()"
        aria-label="Cancel"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
